import React from "react";
import { Route, Switch } from "react-router-dom";

import ExceptionPage from "./exception/ExceptionPage";
import NietGevondenPage from "./notFound/NietGevondenPage";
import ParentHistoryComponent from "./common/ParentHistoryComponent";
import TestPage from "./TestPage";

import DemoPage from "./demo/DemoPage";

import GeneesmiddelOverzichtPage from "./geneesmiddelOverzicht/GeneesmiddelOverzichtPage";
import GeneesmiddelDetailPage from "./geneesmiddelDetail/GeneesmiddelDetailPage";
import VerbodenStofDetailPage from "./verbodenStofDetail/VerbodenStofDetailPage";

export const getRoutes = (match) => {

	return (
		<Switch>
			<Route path={`${match.url}/geneesmiddeloverzicht`} component={GeneesmiddelOverzichtPage} />
			<Route path={`${match.url}/geneesmiddel/:geneesmiddelId?`} component={GeneesmiddelDetailPage} />
			<Route path={`${match.url}/verbodenstof/:geneesmiddelId?/:verbodenStofId?`} component={VerbodenStofDetailPage} />

			<Route path={`${match.url}/demo`} component={DemoPage} />
			<Route path={`${match.url}/:accountId/demo/new`} render={(props) => <DemoPage {...props} isNew />} />

			<Route path={`${match.url}/parentHistory/back`} component={ParentHistoryComponent} />
			<Route path={`${match.url}/parentHistory/path`} component={ParentHistoryComponent} />
			<Route path={`${match.url}/exception`} component={ExceptionPage} />

			<Route path={`${match.url}/testpage`} component={TestPage} />

			<Route exact path={`${match.url}`} component={GeneesmiddelOverzichtPage} />
			<Route exact path={`${match.url}/`} component={GeneesmiddelOverzichtPage} />
			<Route path={`${match.url}/*`} component={NietGevondenPage} />
		</Switch>
	);
};